<template>
    <span uk-spinner></span>
</template>